export const customerServiceUser = 1
export const admin = 99
export const employee = 2
export const driver = 3
export const manager = 4
export const owner = 98
